import React from 'react';
import { observer } from 'mobx-react';
import { Select, Button, Space } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

const findCategory = (categories, id) => categories.find(c => c.id === id);

@observer
export class ItemCategory extends React.Component {
    update = (value) => {
        this.props.update(this.props.index, value);
    }

    remove = () => {
        this.props.remove(this.props.index);
    }

    render() {
        const { index, id, categories } = this.props;

        const options = categories.map(cat => {
            const parent = cat.parentId ? findCategory(categories, cat.parentId) : null;
            const label = parent ? `${parent.title} > ${cat.title}` : cat.title;
            return { value: cat.id, label };
        });

        return (
            <Space.Compact style={{ width: '100%' }}>
                <Select
                    placeholder={`Category #${index + 1}`}
                    value={id || undefined}
                    onChange={this.update}
                    options={options}
                    showSearch
                    filterOption={(input, option) =>
                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                    }
                    style={{ flex: 1 }}
                />
                <Button
                    icon={<DeleteOutlined />}
                    onClick={this.remove}
                    danger
                />
            </Space.Compact>
        );
    }
}
